export enum SpeechEngineVersions {
    Nephilim = 1,
    Skidbladnir = 2,
}